import "core-js/modules/es6.regexp.replace";
import Cookies from 'js-cookie';
import { getParams, getFilterUrl } from "@/utils/index";
import { isWX } from "@/utils/nativebridge";
var TokenKey = process.env.VUE_APP_WX_TOKEN_KEY;
var SysTokenKey = process.env.VUE_APP_ADMIN_TOKEN_KEY;
var AppTokenKey = process.env.VUE_APP_TOKEN_KEY;
export function getToken() {
  return Cookies.get(TokenKey);
}
export function setToken(token) {
  return Cookies.set(TokenKey, token);
}
export function removeToken() {
  return Cookies.remove(TokenKey);
}
export function getAppToken() {
  return Cookies.get(AppTokenKey);
}
export function setAppToken(token) {
  return Cookies.set(AppTokenKey, token);
}
export function removeAppToken() {
  return Cookies.remove(AppTokenKey);
}
export function getSysToken() {
  return Cookies.get(SysTokenKey);
}
export function setSysToken(token) {
  return Cookies.set(SysTokenKey, token);
}
export function removeSysToken() {
  return Cookies.remove(SysTokenKey);
}
//微信授权登录
function wxLogin() {
  //系统未绑定微信公众号(不做授权处理)
  if (process.env.VUE_APP_BIND_WX_GZH === '0') return;

  //微信环境
  if (isWX()) {
    var rurl = location.href;
    if (rurl.indexOf('?') == -1) {
      rurl += '?v=1';
    }
    location.href = process.env.VUE_APP_WX_LOGIN_API + '?rurl=' + encodeURIComponent(rurl);
  }
}

//获取 wxtoken
export function getWxToken() {
  var token = getToken();
  var params = getParams();
  if (params.token) {
    // 微信端授权后返回
    setToken(decodeURIComponent(params.token.replace(/"/g, "")));
    location.href = getFilterUrl("token"); //过滤 token
  } else if (token) {
    // cookie中已存在
    return token.replace(/"/g, "");
  } else {
    wxLogin();
  }
}